import Main from "./pages/Main_Page/main";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sacraments from "./pages/Sacraments/sacraments";
import About from "./pages/About/about";
import Chaplet from './pages/Chaplets/chaplet'
import Symbols from "./pages/HS-Symbols/symbol";
import ChristianSymbols from "./pages/C-Symbols/c-symbol";
import Easter from "./pages/Easter/easter";
import Lady from "./pages/Our-Lady/lady";
import Dogmas from "./pages/NSA-Dogmas/nsa-dogmas";
import NSAHist from "./pages/NSA-Hist/nsa-hist";
import NSADocs from "./pages/NSA-Docs/nsa-docs";
import NSAPop from "./pages/NSA-Pop/nsa-pop";
import SaintJ from "./pages/Saint-Joseph/SaintJ";
import SjIte from "./pages/SJ-ITE/sj-ite";
import SjDocs from './pages/SJ-Docs/sj-docs';
import SJDev from './pages/SJ-Dev/sj-dev';
import SJLife from './pages/SJ-Life/sj-life';
import Wisdom from "./pages/HS-Wisdom/hs-wisdom";
import HsGift from "./pages/HS-Gifts/hs-gifts";
import Understanding from "./pages/HS-Understanding/hs-understanding";
import Advice from "./pages/HS-Advice/hs-advice";
import Fortress from "./pages/HS-Fortress/hs-fortress";
import Science from "./pages/HS-Science/hs-science";
import Mercy from "./pages/HS-Mercy/hs-mercy";
import Fear from "./pages/HS-Fear/hs-fear";
import Gestures from './pages/Gestures/gestures'
import FirstCommandment from './pages/Commandments-List/First-C/first-c'
import SecondCommandment from './pages/Commandments-List/Second-C/second-c'
import ThirdCommandment from './pages/Commandments-List/Third-C/third-c'
import FourthCommandment from './pages/Commandments-List/Fourth-C/fourth-c'
import FifthCommandment from './pages/Commandments-List/Fifth-C/fifth-c'
import SixthCommandment from './pages/Commandments-List/Sixth-C/sixth-c'
import SeventhCommandment from './pages/Commandments-List/Seventh-C/seventh-c'
import EigthCommandment from "./pages/Commandments-List/Eight/eigth-c";
import NinthCommandment from './pages/Commandments-List/Ninth-C/ninth-c'
import TenthCommandment from './pages/Commandments-List/Tenth-C/tenth-c'
import Thithe from "./pages/Tithe/tithe";
import Purgatory from './pages/Purgatory/purgatory'
import Commandment from './pages/Commandments/commandments';
import Benedict from "./pages/Benedict/benedict";
import SevenTimesOF from "./pages/Seven-Our-Father/SOF";
import Prayers from "./pages/Fifhteen-Prayers/prayers";
import Hearts from "./pages/Hearts/hearts";
import HeartJesus from "./pages/Heart-Jesus/heart-jesus";
import HeartJoseph from "./pages/Heart-Joseph/heart-joseph";
import HeartMary from "./pages/Heart-Mary/heart-mary";
import Angel from "./pages/Angels-Hierarchy/angel";
import GuardianAngel from "./pages/Guardian-Angel/guardian-angel";
import SacredFace from "./pages/Sacred-Face/sacred-face";
import Relics from "./pages/Relics/relics";
import Advent from "./pages/Advent/advent";
const AppRoutes = () => { 
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Sacramentos" element={<Sacraments/>}/>
        <Route path="/Sobre" element={<About/>}/>
        <Route path="/Tercos" element={<Chaplet/>}/>
        <Route path="/Gestos" element={<Gestures/>}/>
        <Route path="/Dizimo" element={<Thithe/>}/>
        <Route path="/Purgatorio" element={<Purgatory/>}/>
        <Route path="/Bento" element={<Benedict/>}/>
        <Route path="/7-Pai-Nosso" element={<SevenTimesOF/>}/>
        <Route path="/15-Oracoes-Santa-Brigida" element={<Prayers/>}/>
        <Route path="/Hierarquia-Angelical" element={<Angel/>}/>
        <Route path="/Anjo-Da-Guarda" element={<GuardianAngel/>}/>
        <Route path="/Sagrada-Face" element={<SacredFace/>}/>
        <Route path="/Reliquias" element={<Relics/>}/>
        <Route path="/Advento" element={<Advent/>}/>
          {/* ------- Coracoes -----------*/}
        <Route path="/Sagrados-Coracoes" element={<Hearts/>}/>
        <Route path="/Jesus" element={<HeartJesus/>}/>
        <Route path="/Jose" element={<HeartJoseph/>}/>
        <Route path="/Maria" element={<HeartMary/>}/>

            {/* ------- Espirito Santo -----------  */}
        <Route path="/Simbolos-Espirito" element={<Symbols/>}/>
        <Route path="/Dons-Espirito" element={<HsGift/>}/>
        <Route path="/Espirito-Sab" element={<Wisdom/>}/>
        <Route path="/Espirito-Ent" element={<Understanding/>}/>
        <Route path="/Espirito-Cons" element={<Advice/>}/>
        <Route path="/Espirito-Fort" element={<Fortress/>}/>
        <Route path="/Espirito-Cienc" element={<Science/>}/>
        <Route path="/Espirito-Pied" element={<Mercy/>}/>
        <Route path="/Espirito-TD" element={<Fear/>}/>
        {/* ----------------Mandamentos----------------------- */}=
        <Route path="/Mandamentos" element={<Commandment/>}/>
        <Route path="/MD-1" element={<FirstCommandment/>}/>
        <Route path="/MD-2" element={<SecondCommandment/>}/>
        <Route path="/MD-3" element={<ThirdCommandment/>}/>
        <Route path="/MD-4" element={<FourthCommandment/>}/>
        <Route path="/MD-5" element={<FifthCommandment/>}/>
        <Route path="/MD-6" element={<SixthCommandment/>}/>
        <Route path="/MD-7" element={<SeventhCommandment/>}/>
        <Route path="/MD-8" element={<EigthCommandment/>}/>
        <Route path="/MD-9" element={<NinthCommandment/>}/>
        <Route path="/MD-10" element={<TenthCommandment/>}/>

        {/* ----------------Nossa Senhora----------------------- */}
        <Route path="/NSA" element={<Lady/>}/>
        <Route path="/NSA-Dogmas" element={<Dogmas/>}/>
        <Route path="/NSA-Hist" element={<NSAHist/>}/>
        <Route path="/NSA-Docs" element={<NSADocs/>}/>
        <Route path="/NSA-Pop" element={<NSAPop/>}/>
        {/*  -------------São José---------------------- */}
        <Route path="/SJ" element={<SaintJ/>}/>
        <Route path="/SJ-Docs" element={<SjDocs/>}/>
        <Route path="/SJ-Dev" element={<SJDev/>}/>
        <Route path="/SJ-ITE" element={<SjIte/>}/>
        <Route path="/SJ-Life" element={<SJLife/>}/>
        <Route path="/Pascoa" element={<Easter/>}/>
        <Route path="/Simbolos-Cristaos" element={<ChristianSymbols/>}/>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;